<ng-container *ngIf="formControl$ | async as formControl">
  <ng-container *ngFor="let validation of validations$ | async">
    <span class="error-message" *ngIf="formControl.invalid && formControl.errors[validation.Type]">{{ getErrorMessage(formControl.errors[validation.Type], validation.Message) }}</span>
  </ng-container>
</ng-container>